import { useToast } from "vue-toastification";

function formatPayload(message) {
    if (typeof message === 'object' && message !== null && (message.title || message.description || message.message)) {
        const title = message.title ? `<strong class="toast-title">${message.title}</strong>` : '';
        const body = message.description || message.message ? `<span class="toast-description">${message.description || message.message}</span>` : '';
        return {
            content: `<div class="toast-wrapper">${title}${body}</div>`,
            dangerouslyHTMLString: true
        };
    }
    return message;
}

export default {
    default: function (message = "Default", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast(payload, { position });
    },

    success: function (message = "Success", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.success(payload, { position });
    },

    info: function (message = "Info", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.info(payload, { position });
    },

    warning: function (message = "Warning", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.warning(payload, { position });
    },

    error: function (message = "Error", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.error(payload, { position });
    },

    successFlip: function (status = null, message = "", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.success(payload, { position });
    },

    successInfo: function (status = null, message = "", position = "bottom-center") {
        const toast = useToast();
        const payload = formatPayload(message);
        toast.success(payload, { position });
    },
};
